import { AppConfig, usePermissions } from '@ltvco/refresh-lib/ctx';
import { updateSetting, useSession } from '@ltvco/refresh-lib/v1';
import { AddeptIoMemberPerks as SharedAddeptIoMemberPerks } from '@ltvco/refresh-lib/v2';
import { useFeatureIsOn } from '@ltvco/refresh-lib/vendors';
import { useCallback, useContext, useEffect } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';

import { isEligibleForMemberPerks } from '../../utils/memberPerks';

export const AddeptIoMemberPerks = () => {
  const navigate = useNavigate();
  const { logError } = useContext(AppConfig);
  const {
    session: { account },
    setSession,
  } = useSession();
  const { isFreePlan } = usePermissions();
  const isMemberPerksEnabled = useFeatureIsOn('BUMP-5186');

  useEffect(() => {
    document.title = 'Member Perks - Bumper';
  }, []);

  const hideMemberPerksPageForCurrentSession = useCallback(() => {
    if (!account) return;

    setSession({
      account: {
        ...account,
        account: {
          ...account.account,
          user_settings: {
            ...account.account.user_settings,
            hide_addept_io_member_perks_page: true,
          },
        },
      } as typeof account,
    });
  }, [account, setSession]);

  const handleContinueToVehicleReport = useCallback(() => {
    hideMemberPerksPageForCurrentSession();

    updateSetting({
      setting: 'hide_addept_io_member_perks_page',
      state: true,
    }).catch((error) => {
      logError(
        'Error updating hide_addept_io_member_perks_page',
        error as Error,
      );
    });

    navigate('/dashboard');
  }, [hideMemberPerksPageForCurrentSession, logError, navigate]);

  if (
    !isMemberPerksEnabled ||
    isFreePlan ||
    !isEligibleForMemberPerks(account)
  ) {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <SharedAddeptIoMemberPerks
      onContinueToVehicleReport={handleContinueToVehicleReport}
    />
  );
};
